export default __webpack_public_path__ + "static/media/1328.5fec5199.png";